import { colors } from '../../colors';
export function colorToValue(color) {
  return colors[color] || color;
}